import { ErrorHandler, inject, Injectable } from "@angular/core";
import { ErrorDumpService } from "./error-dump.service";
import { WeblogCategory, WebLoggerService } from "./web-logger.service";

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {

  private webLogger = inject(WebLoggerService)
  private errorDump = inject(ErrorDumpService)

  constructor() {
    window.addEventListener('error', event => this.handleError(event))
    window.addEventListener('unhandledrejection', event => this.handleError(event))
  }

  handleError(error: unknown) {
    if (this.shouldIgnore(error)) {
      return
    }
    console.error(error)
    this.webLogger.reportError(WeblogCategory.ui, {
      url: location.href,
      ...this.errorDump.dumpError(error),
    })
  }

  private shouldIgnore(error: unknown): boolean {
    if (error instanceof ErrorEvent) {
      return this.isChromeExtensionSource(error.filename)
        || this.isAngularDevToolsNoise(error.message)
        || this.shouldIgnore(error.error)
    }
    if (error instanceof PromiseRejectionEvent) {
      return this.shouldIgnore(error.reason)
    }
    if (error instanceof Error) {
      return this.isChromeExtensionSource(error.stack)
        || this.isAngularDevToolsNoise(error.message)
    }
    if (typeof error === 'string') {
      return this.isChromeExtensionSource(error)
        || this.isAngularDevToolsNoise(error)
    }
    return false
  }

  private isChromeExtensionSource(value?: string | null): boolean {
    return !!value?.includes('chrome-extension://')
  }

  private isAngularDevToolsNoise(value?: string | null): boolean {
    return !!value?.includes('Angular DevTools')
  }

}
